import type { CreateRight } from 'App/resources/AllIWant';
import type ActivityType from 'App/resources/Model/ActivityType';

/** Expects the types the user's role may pick (`getActivityTypes('appointment', true)`). */
export function visitTypes<T extends Pick<ActivityType, 'name' | 'isVisit'>>(appointmentTypes: readonly T[]): T[] {
	return appointmentTypes.filter(type => type.isVisit).sort((a, b) => a.name.localeCompare(b.name));
}

/** Without a visit type only an admin is offered the action, as the way to set one up. */
export function offersBookVisits({
	canCreateAppointments,
	appointmentRight,
	administrator,
	appointmentTypes
}: {
	canCreateAppointments: boolean;
	/** `self.createRights.Appointment`, whose `OWN` covers any company. */
	appointmentRight: CreateRight | undefined;
	administrator: boolean;
	appointmentTypes: readonly Pick<ActivityType, 'name' | 'isVisit'>[];
}): boolean {
	return (
		canCreateAppointments &&
		(appointmentRight === 'ALL' || appointmentRight === 'OWN') &&
		(visitTypes(appointmentTypes).length > 0 || administrator)
	);
}
